import { PAGE_ROUTES } from '@/components/nav/utils/url-builders';
import { isPageActive } from '@/lib/is-page-active';
import { leadStore } from '@/models/stores/leads';
import { useEffect } from 'react';

const useLeadsPageHydrateLocal = () => {
  const isLeadsPageActive = isPageActive(PAGE_ROUTES.LEADS);

  useEffect(() => {
    if (!isLeadsPageActive) {
      return;
    }

    const hydrateTasks = async () => {
      await Promise.all([leadStore.hydrateLocal()]);
    };

    hydrateTasks();
  }, [isLeadsPageActive]);
};

export default useLeadsPageHydrateLocal;
